export enum VisualsDashboardRangesColorEnum {
    EMERALD = '#10b981',
    LIME = '#84cc16',
    YELLOW = '#facc15',
    AMBER = '#f59e0b',
    ORANGE = '#f97316',
    RED = '#ef4444',
}

export enum VisualsDashboardTextColorEnum {
    EMERALD = '#065f46',
    LIME = '#3f6212',
    AMBER = '#92400e',
    ORANGE = '#7c2d12',
    RED = '#991b1b',
}

export enum VisualsDashboardBackgroundColorEnum {
    EMERALD = 'rgba(16, 185, 129, 0.12)',
    LIME = 'rgba(132, 204, 22, 0.12)',
    AMBER = 'rgba(245, 158, 11, 0.12)',
    ORANGE = 'rgba(249, 115, 22, 0.12)',
    RED = 'rgba(239, 68, 68, 0.12)',
}

export const getDashboardColorByPercentage = (percentage: number): VisualsDashboardRangesColorEnum => {
    switch (true) {
        case percentage === 100:
            return VisualsDashboardRangesColorEnum.EMERALD;
        case percentage >= 80:
            return VisualsDashboardRangesColorEnum.LIME;
        case percentage >= 60:
            return VisualsDashboardRangesColorEnum.YELLOW;
        case percentage >= 40:
            return VisualsDashboardRangesColorEnum.AMBER;
        case percentage >= 20:
            return VisualsDashboardRangesColorEnum.ORANGE;
        default:
            return VisualsDashboardRangesColorEnum.RED;
    }
};
